import React from 'react';
import './SendButton.css';
import { useLanguage } from '../../../../LanguageProvider';

const SendButton = ({ onClick, disabled }) => {
    const { getTranslation } = useLanguage();

    return (
        <button className="send-button" onClick={onClick} disabled={disabled}>
            {getTranslation('send')}
        </button>
    );
};

export default SendButton;
